module.exports = __webpack_public_path__ + "media/images/devise/icon_3-d70c059ae9519c00849bf1dd5970459e.svg";